import { RoutePath } from '../_enums/route-path.enum';

const generateUrlToUserOan = (
  userName: string
): string => {
  let url = '';

  url = `${RoutePath.MY_OAN}/${userName ? userName : ''}`;

  return url;
};

export { generateUrlToUserOan };
